import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MaintenanceState {
  isMaintenanceMode: boolean;
  lastErrorStatus?: number;
  errorCount: number;
}

const initialState: MaintenanceState = {
  isMaintenanceMode: false,
  lastErrorStatus: undefined,
  errorCount: 0,
};

export const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.isMaintenanceMode = action.payload;
      if (!action.payload) {
        // Reset error count when exiting maintenance mode
        state.errorCount = 0;
        state.lastErrorStatus = undefined;
      }
    },
    incrementErrorCount: (state, action: PayloadAction<number>) => {
      state.errorCount += 1;
      state.lastErrorStatus = action.payload;
      
      // Enter maintenance mode if we've had multiple errors
      // or if it's a 500 error (server error)
      if (state.errorCount >= 2 || action.payload >= 500) {
        state.isMaintenanceMode = true;
      }
    },
    resetErrorCount: (state) => {
      state.errorCount = 0;
      state.lastErrorStatus = undefined;
    },
  },
});

export const { setMaintenanceMode, incrementErrorCount, resetErrorCount } = maintenanceSlice.actions;
export default maintenanceSlice.reducer; 